module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"WBSElementRemarks\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-element-remarks/wbs-element-remarks.component.html
// module id = ./src/app/wbs-element-remarks/wbs-element-remarks.component.html
// module chunks = main